var appObj = {
    // Variables
    agreementsFlag: '',
    personalised: false,
    nonPersonalised: false,
    conditions10off: '',
    conditionsFreeDelivery: '',
    jsonEmail: '',
    jsonName: '',
    formData: new FormData(),
    campaign_type_name: 'Data_Capture_Veet_10_precent_off_2020',
    check1: false,
    check2: false,
    check3: false,
    check4: false,
    check5: false,
    check6: false,
    check7: false,

    // Methods
    myFBLoginButton: function () {
        // needs to be called on click
        FB.login(function () {
            checkLoginState();
        }, { scope: 'email,public_profile' });
    },
    facebookSupport: function () {
        window.fbAsyncInit = function () {
            FB.init({
                appId: '250457862931971',
                cookie: true,
                xfbml: true,
                version: 'v4.0'
            });

            FB.AppEvents.logPageView();
        };

        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

        function checkLoginState() {
            FB.api('/me', { fields: 'name, email' }, function (response) {
                console.log('name is:' + response.name);
                console.log('email is:' + response.email);

                document.getElementById('email').value = response.email;
                document.getElementById('name').value = response.name;
            });
        }
    },
    getCookie: function (name) {
        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
    },
    setCookie: function (name, value, days) {
        var d = new Date;
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    },
    copyToClipboard: function () {
        /* Get the text field */
        var copyText = $(".thx_popup:visible").find('.code').text();
        var val = document.createElement('input');

        /* Select the text field */
        document.body.appendChild(val);
        val.value = copyText;
        val.select();
        val.setSelectionRange(0, 99999); /*For mobile devices*/
        document.execCommand("copy", false);
        val.remove();
    },
    showPopup: function () {
        $('.cta-button-dc').on('click', function (event) {
            var popupRel = $(this).prop('id');
            var popup = $('.popup-container.dc_popup[data-rel="' + popupRel + '"]');
            appObj.agreementsFlag = popupRel;

            $(popup).css({
                display: 'block',
                transition: "opacity 200ms",
                opacity: "1",
                overflowY: 'auto'
            }).addClass('visible');

            $('body').css({
                overflow: 'hidden'
            })

            appObj.validationFoo();
        })
    },
  	callPopupWithDelay: function () {
      var cookieCheck = appObj.getCookie('scf365d');
      var smallCookieCheck = appObj.getCookie('scf7d');
      
      if(cookieCheck === 'true' || smallCookieCheck === 'true') {
      	return false;
      } else {
      	setTimeout(function(){
          $('.cta-button-dc.visible-cta').click();
        }, 30000)
      }
    },
    hidePopup: function () {
        var close = $('.popup-close');

        $(close).on('click', function () {
            $('.visible form').off();
            $(this).closest('.popup-container').css({
                display: 'none',
                transition: "opacity 200ms",
                opacity: "0",
                overflowY: 'hidden'
            }).removeClass('visible thank-you-visible');

            $('body').css({
                overflow: 'auto'
            })
            
            appObj.setCookie('scf7d', true, 7);
        });
    },
    showMoreBtn: function () {
        $('.learn-more__trigger').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('no-shadow');
            $(this).find('span').toggleClass('active');
            $(this).prev().toggleClass('expanded');
        });
    },
    showThankYouPopup: function () {
        var personalised = $('.visible input#personalised');
        var nonPersonalised = $('.visible input#non_personalised');
        var conditions = $('.visible input#conditions');

        if (personalised.length != 0 && conditions.length != 0) {
            if (conditions.is(':checked') && (personalised.is(':checked') || nonPersonalised.is(':checked'))) {
                $('.thx_popup-both').css({
                    display: 'block',
                    transition: "opacity 200ms",
                    opacity: "1",
                    overflowY: 'auto'
                }).addClass('thank-you-visible');
            } else if (conditions.is(':checked') && personalised.not(':checked') && nonPersonalised.not(':checked')) {
                $('.thx_popup-second').css({
                    display: 'block',
                    transition: "opacity 200ms",
                    opacity: "1",
                    overflowY: 'auto'
                }).addClass('thank-you-visible');
            }
        }

        $('.visible .popup-close').click();
    },
    validationFoo: function () {
        const form = document.querySelector('.visible .popup-form');
        const inputsToCheck = document.querySelectorAll('.visible input:required');
        const inputsArray = [].slice.call(inputsToCheck);

        inputsArray.forEach(function (item) {
            item.addEventListener('input', function (event) {
                // Each time the user types something, we check if the
                // form fields are valid.
                if (item.validity.valid) {
                    // In case there is an error message visible, if the field
                    // is valid, we remove the error message.
                    item.closest('.validate').querySelector('.error_message').style.display = 'none';
                    if (item.id === 'conditions') {
                        item.closest('label').querySelector('.dynamic-textarea').style.color = '#3F3F3F';
                    }
                } else {
                    // If there is still an error, show the correct error
                    item.closest('.validate').querySelector('.error_message').style.display = 'block';
                    if (item.id === 'conditions') {
                        item.closest('label').querySelector('.dynamic-textarea').style.color = '#f00';
                    }
                }

                if ($('.visible .terms_container input:checked').length > 0 && $('.visible .form-row input:valid').length === 2) {
                    $('.cta-button').addClass('validation_positive');
                } else {
                    $('.cta-button').removeClass('validation_positive');
                }
            });
        });

        $(form).on('submit', function (event) {
            inputsArray.forEach(function (item) {
                if (!item.validity.valid) {
                    // If they aren't, we display an appropriate error message
                    item.closest('.validate').querySelector('.error_message').style.display = 'block';
                    if (item.id === 'conditions') {
                        item.closest('label').querySelector('.dynamic-textarea').style.color = '#f00';
                    }

                    // Then we prevent the form from being sent by canceling the event
                    event.preventDefault();
                    return false;
                } else {
                    item.closest('.validate').querySelector('.error_message').style.display = 'none';
                    if (item.id === 'conditions') {
                        item.closest('label').querySelector('.dynamic-textarea').style.color = '#3F3F3F';
                    }
                }
            });

            // if the inputsArray fields are valid, we let the form submit
            if ($('.visible .terms_container #conditions:checked').length > 0 && $('.visible .form-row input:valid').length === 2) {
                appObj.personalised = $('.visible #personalised').is(':checked');
                appObj.nonPersonalised = $('.visible #non_personalised').is(':checked');
                appObj.conditions10off = $('.visible #conditions').is(':checked');
                appObj.conditionsFreeDelivery = $('.visible #conditions').is(':checked');
                appObj.jsonName = $('.visible #inputName').val();
                appObj.jsonEmail = $('.visible #inputEmail').val();
                appObj.check1 = $('.visible #sensitive').is(':checked');
                appObj.check2 = $('.visible #normal').is(':checked');
                appObj.check3 = $('.visible #legs').is(':checked');
                appObj.check4 = $('.visible #bikini').is(':checked');
                appObj.check5 = $('.visible #face').is(':checked');
                appObj.check6 = $('.visible #arms').is(':checked');
                appObj.check7 = $('.visible #underarms').is(':checked');

                if (appObj.agreementsFlag == '10off') {
                    appObj.conditionsFreeDelivery = false;
                    appObj.campaign_type_name = 'Data_Capture_Veet_10_precent_off_2020';
                } else if (appObj.agreementsFlag == 'free_delivery') {
                    appObj.conditions10off = false;
                    appObj.campaign_type_name = 'Data_Capture_Veet_free_delivery_2020';
                }

                myJson = {
                    "FirstName": appObj.jsonName,
                    "Emails": [
                        {
                            "EmailAddress": appObj.jsonEmail,
                            "DeliveryStatus": "G"
                        }
                    ],
                    "TierCode": "RBVETSTRTIER1",
                    "OrigActivityDate": new Date(),
                    "JsonExternalData": {
                        "UnmappedAttributes": {
                            "Optin_Presonalised_Email": appObj.personalised,
                            "Optin_Generic_Email": appObj.nonPersonalised,
                            "RB_Symptoms": [
                                {
                                    "question": "what_is_your_skin_type?",
                                    "normal": appObj.check1,
                                    "sensitive": appObj.check2
                                },
                                {
                                    "question": "what_part_of_your_body_do_use_veet_products_for?",
                                    "legs": appObj.check3,
                                    "bikini": appObj.check4,
                                    "face": appObj.check5,
                                    "arms": appObj.check6,
                                    "underarms": appObj.check7
                                }
                            ],
                            "TCs_Brand": "true",
                            "Lead_Consumer_Brand_Opt-in": "true",
                            "RB_Commercial_Brand_Opt-in": "true",
                            "Brand": "Veet",
                            "Channel_source": "veet_website",
                            "Campaign_date": "2020-09-20",
                            "Campaign_type_name": appObj.campaign_type_name,
                            "Form_time": new Date(),
                            "FromURL": "https://www.veet.co.uk/",
                            "FormID": "12",
                            "RegTime": new Date()
                        },
                        "Agreements": [
                          	{
                                "id": 33,
                                "ConsentAcceptedInd": appObj.nonPersonalised || appObj.personalised,
                                "MandatoryInd": false
                            },
                            {
                                "id": 34,
                                "ConsentAcceptedInd": appObj.conditions10off,
                                "MandatoryInd": false
                            }                            
                        ]
                    }
                }

                appObj.submitFoo();
                event.preventDefault();
                return false;
            } else {
                event.preventDefault();
                return false;
            }
        });
    },
    hash256: function (str) {
        var shaObj = new jsSHA('SHA-256', 'TEXT');
        shaObj.update(str);
        var hash = shaObj.getHash('HEX');
        console.log(hash);
        return hash;
    },
  	saveInCustomer: function(email) {
      var hiddenForm = $('.popup-container-main .hidden-contact-form form');
      hiddenForm.find("[name='contact[email]']").val(email);
      var formData = hiddenForm.serialize();

      $.ajax({
        type: "POST",
        url: "/contact#contact_form",
        data: formData,
        success: function() {},
        error: function () {}
      });
  	},
    submitFoo: function () {
        appObj.formData.append('data', JSON.stringify(myJson))
        axios({
            method: 'post',
            url: 'https://rb-forms-production.frankfurt.rbdigitalcloud.com/api/create?form_id=12',
            data: appObj.formData,
            header: {
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data',
            },
        })
            .then(function (response) {
                if (response.status == 200 && response.data.status == true) {
                    appObj.showThankYouPopup();
                  	appObj.setCookie('scf365d', true, 365);
                  
                  	// Save in customer
                    if (appObj.personalised || appObj.nonPersonalised) {
                      appObj.saveInCustomer(appObj.jsonEmail);
                    }
                  
                    document.querySelector('.popup-form').reset();

                    // Hashing functions
                    function pushSHAtoDataLayer(email) {
                        //pushing hashed email address to datalayer
                        dataLayer.push({ email_sha256: appObj.hash256(email) });
                        //calling Krux to read the data from datalayer and send to Krux
                        Krux(
                            'ns:reckittbenckiserukhealth',
                            'page:load',
                            function (err) {
                                console.log('krux err: ' + err);
                            },
                            { pageView: true }
                        );
                    }

                    pushSHAtoDataLayer($('#inputEmail').val());
                }
                else {
                    console.log("200 status false");
                }
            })
            .catch(function (error) {
                if (error.response) {
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log('Error, ', error.message);
                }
                console.log(error.config);
            });
    },
    tooltipFoo: function () {
        $('.btn-copy').on('click', function () {
            appObj.copyToClipboard();
            $(this).find('.tooltip').css({ 'display': 'block' }).addClass('fade-animation');

            setTimeout(() => {
                $(this).find('.tooltip').removeClass('fade-animation');
            }, 2000);
        });
    },
    bgColourForVeetMan: function() {
      if (window.location.href.indexOf("veet-men") > -1) {
        $('.best_sellers').addClass('veet-men');
        
        $('.popup_content .popup_content-header, .cta-button, .popup_content.thx_popup .best_sellers ul li a').css({
          'background': '#ff7300'
        })
        
        $('.popup_content .popup_content-main .email-login-ct .form-row input').css({
        	'border-color': '#ff7300'
        })
        
        $('.popup_content.thx_popup .thx_popup-main h2, .popup_content.thx_popup .thx_popup-main h3').css({
        	'color': '#000'
        })
        
        $('.popup_content .popup_content-main .email-login-ct .checkbox-container .checkbox-row label i, .terms_container .radio-row i').addClass('orange');
        
        $('.shop-range-woman').css({display: 'none'});
        $('.shop-range-men').css({display: 'block'});
      }
    },
    // Call functions
    calloutFoo: function () {
        appObj.showPopup();
        appObj.hidePopup();
        appObj.showMoreBtn();
        appObj.tooltipFoo();
      	appObj.callPopupWithDelay();
      	appObj.bgColourForVeetMan();
    }
}

appObj.calloutFoo();

